import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../../components/feature/TrustBar';
import ProcessSection from '../../components/feature/ProcessSection';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTA from '../../components/feature/FinalCTA';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import ServiceAreasSection from '../../components/feature/ServiceAreasSection';
import ServiceDetailItem from './components/ServiceDetailItem';
import { COMPANY, SERVICES } from '../../mocks/siteData';

const SERVICE_DETAILS = [
  {
    id: 'kitchen-remodeling',
    label: 'Most Popular',
    image: 'https://public.readdy.ai/ai/img_res/3c8a21bbfea27334e33608cbc657392b.jpg',
    details: ['Custom cabinetry design and installation', 'Premium countertop selection and fabrication', 'Island design and custom sizing', 'Appliance integration and lighting design', 'Full layout changes with plumbing and electrical coordination', 'Backsplash tile, flooring, and trim work'],
  },
  {
    id: 'bathroom-remodeling',
    label: 'Top Rated',
    image: 'https://readdy.ai/api/search-image?query=Opulent%20luxury%20master%20bathroom%20renovation%20with%20sculptural%20freestanding%20white%20soaking%20tub%2C%20dramatic%20floor-to-ceiling%20large%20format%20marble%20slab%20walls%20with%20gold%20veining%2C%20frameless%20glass%20walk-in%20shower%20with%20brushed%20gold%20rain%20head%2C%20floating%20double%20vanity%20with%20concrete%20vessel%20sinks%2C%20backlit%20mirror%2C%20warm%20ambient%20lighting%2C%20serene%20spa%20sanctuary%2C%20architectural%20editorial%20photography%2C%20ultra%20premium%20residential%20Florida%20bathroom&width=1200&height=900&seq=bcr-svc-detail-bath-v1&orientation=landscape',
    details: ['Custom tile design and large format installation', 'Freestanding tub and frameless shower enclosures', 'Floating vanity and custom cabinetry', 'Lighting design and smart fixture integration', 'Heated floor installation', 'Full plumbing relocation and layout changes'],
  },
  {
    id: 'home-remodeling',
    label: 'Full Service',
    image: 'https://readdy.ai/api/search-image?query=Breathtaking%20open%20floor%20plan%20full%20home%20renovation%20interior%20with%20soaring%2014%20foot%20coffered%20ceilings%2C%20flowing%20open%20living%20dining%20kitchen%20connected%20space%2C%20custom%20floor%20to%20ceiling%20built-in%20millwork%20throughout%2C%20dramatic%20stone%20accent%20fireplace%2C%20premium%20engineered%20wide%20plank%20hardwood%20floors%2C%20warm%20sophisticated%20amber%20pendant%20lighting%2C%20luxury%20modern%20Florida%20interior%20design%2C%20cinematic%20ultra%20wide%20angle%20architectural%20photography&width=1200&height=900&seq=bcr-svc-detail-home-v1&orientation=landscape',
    details: ['Whole-home and multi-room renovation planning', 'Structural layout changes and additions', 'Cohesive interior design and finish selection', 'Kitchen and bathroom integration', 'Flooring, lighting, and trim throughout', 'Single point of project management from start to finish'],
  },
  {
    id: 'full-home-renovations',
    label: 'Complete Transform',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20complete%20luxury%20home%20renovation%20transformation%2C%20expansive%20open%20plan%20interior%20with%20dramatic%20high%20vaulted%20ceilings%20and%20architectural%20details%2C%20premium%20custom%20cabinetry%20and%20millwork%20throughout%20every%20wall%2C%20rich%20warm%20hardwood%20floors%20flowing%20through%20all%20spaces%2C%20stone%20fireplace%20feature%20wall%2C%20sophisticated%20modern%20furnishings%2C%20warm%20amber%20accent%20lighting%2C%20cinematic%20luxury%20real%20estate%20photography%2C%20ultra%20premium%20Florida%20residential%20renovation&width=1200&height=900&seq=bcr-svc-detail-fullhome-v1&orientation=landscape',
    details: ['Complete floor plan redesign and structural changes', 'Room additions and second-story additions', 'Whole-home material and finish coordination', 'Kitchen, bathroom, and living area integration', 'Flooring, millwork, trim, and lighting throughout', 'Project management from design to final walkthrough'],
  },
  {
    id: 'interior-upgrades',
    label: 'Custom Work',
    image: 'https://readdy.ai/api/search-image?query=Exquisite%20custom%20built-in%20floor-to-ceiling%20dark%20walnut%20library%20cabinetry%20with%20integrated%20display%20shelves%2C%20glass-front%20display%20cabinets%2C%20rolling%20brass%20library%20ladder%2C%20warm%20directed%20accent%20lighting%20highlighting%20rich%20wood%20grain%2C%20elegant%20crown%20molding%20and%20architectural%20millwork%20details%2C%20luxury%20home%20study%20interior%2C%20sophisticated%20dramatic%20warm%20photography%2C%20premium%20Florida%20residential%20craftsmanship&width=1200&height=900&seq=bcr-svc-detail-interior-v1&orientation=landscape',
    details: ['Custom cabinetry design and installation', 'Premium hardwood and tile flooring installation', 'Crown molding, trim, and baseboard work', 'Drywall installation, repair, and finishing', 'Built-in shelving and storage solutions', 'Layout changes and partition wall work'],
  },
  {
    id: 'outdoor-living',
    label: 'Florida Living',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20luxury%20outdoor%20living%20space%20in%20Florida%20home%2C%20expansive%20covered%20pergola%20with%20warm%20string%20lights%20and%20natural%20wood%20beams%2C%20elegant%20outdoor%20kitchen%20with%20stone%20countertops%20and%20built-in%20grill%2C%20premium%20travertine%20tile%20patio%20flooring%2C%20comfortable%20upholstered%20outdoor%20furniture%2C%20lush%20tropical%20landscaping%20surrounding%20the%20space%2C%20warm%20golden%20hour%20lighting%2C%20luxury%20resort-style%20backyard%20entertainment%20area%2C%20cinematic%20architectural%20photography&width=1200&height=900&seq=bcr-svc-detail-outdoor-v1&orientation=landscape',
    details: ['Covered patio and pergola design and construction', 'Outdoor kitchen design with built-in appliances', 'Deck construction — wood, composite, and pavers', 'Travertine and paver installation', 'Outdoor lighting and electrical work', 'Screening, shade structures, and enclosures'],
  },
];

const combinedFaqs = [
  { q: 'Who provides home remodeling near me in Brandon, FL?', a: 'Bay City Remodeling & Bathrooms LLC provides kitchen, bathroom, and full-home remodeling in Brandon, FL and 23+ surrounding communities — backed by 18+ years of local experience and a 5.0-star reputation.' },
  { q: 'How much does a kitchen remodel cost?', a: 'Kitchen remodels vary based on materials, layout changes, and scope. Bay City Remodeling provides free in-home consultations with transparent, accurate estimates before work begins — no surprises.' },
  { q: 'How long does a bathroom remodel take?', a: 'Most bathroom remodels take 2–6 weeks depending on complexity, tile work, and fixture lead times. We provide a detailed schedule before any work starts.' },
  { q: 'How long does a full home renovation take?', a: 'Full home renovations typically range from 2–6 months depending on scope. We develop a complete project schedule with regular communication at every phase.' },
  { q: 'Can you handle multiple rooms at once?', a: 'Yes. Bay City Remodeling coordinates multi-room and whole-home projects under a single structured process — keeping everything cohesive, on schedule, and within scope.' },
  { q: 'Are you licensed and insured in Florida?', a: 'Yes. Bay City Remodeling & Bathrooms LLC is fully licensed, bonded, and carries workers\' compensation and general liability insurance on every project in Brandon, FL.' },
];

export default function ServicesPage() {
  return (
    <div className="font-sans">
      <Navbar />

      {/* 1. Hero */}
      <section
        className="relative min-h-[92vh] w-full flex items-end overflow-hidden"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Breathtaking%20luxury%20home%20renovation%20panorama%20interior%20montage%2C%20dramatic%20premium%20kitchen%20flowing%20into%20elegant%20living%20space%2C%20ultra-luxury%20custom%20cabinetry%20marble%20countertops%20spa%20bathroom%20glimpse%2C%20soaring%20ceilings%20warm%20cinematic%20lighting%2C%20high-end%20residential%20interior%20design%20editorial%20photography%2C%20moody%20atmospheric%20deep%20tones%20with%20warm%20gold%20highlights%2C%20premium%20craftsmanship%20throughout%2C%20luxury%20Florida%20remodeling%20showcase&width=1920&height=1080&seq=bcr-services-hero-v2&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center 35%',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-stone-950 via-stone-950/55 to-stone-900/10" />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-950/80 via-stone-950/35 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-stone-950 to-transparent" />

        <div className="relative z-10 w-full px-6 lg:px-16 xl:px-24 pb-20 pt-40">
          <div className="max-w-4xl">
            <div className="flex items-center gap-3 mb-7">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-star-fill text-accent text-xs" />
                </div>
              ))}
              <div className="w-px h-4 bg-white/20" />
              <span className="text-white/55 text-xs">{COMPANY.rating} · {COMPANY.reviewCount} Reviews · Brandon, FL</span>
            </div>
            <div className="lg:pl-7 relative">
              <div className="absolute left-0 top-0 w-[2px] h-full bg-gradient-to-b from-accent via-accent/50 to-transparent hidden lg:block" />
              <h1 className="font-serif text-[50px] md:text-[66px] lg:text-[78px] text-white leading-[1.0] tracking-tight mb-6" style={{ letterSpacing: '-0.02em' }}>
                Premium Remodeling Services in Brandon, FL
              </h1>
            </div>
            <p className="text-white/60 text-base md:text-lg mb-10 leading-relaxed max-w-2xl">
              Kitchen remodeling, bathroom renovations, full home transformations, and interior upgrades — all designed and executed to the highest standard, tailored to your vision.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link to="/about" className="group inline-flex items-center gap-3 bg-accent hover:bg-accent-dark text-white font-semibold px-8 py-4 rounded-lg transition-colors whitespace-nowrap text-sm">
                Request a Design Consultation
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1 text-xs" />
                </div>
              </Link>
              <a href={`tel:${COMPANY.phoneFull}`} className="inline-flex items-center justify-center gap-2 border border-white/20 hover:border-white/50 bg-white/5 text-white font-medium px-8 py-4 rounded-lg transition-colors whitespace-nowrap text-sm">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-accent" />
                </div>
                {COMPANY.phone}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 2. Trust Bar */}
      <TrustBar />

      {/* 3. All 6 Services — deep detail sections */}
      <section className="bg-white">
        {/* Services header */}
        <div className="px-6 lg:px-16 xl:px-24 py-20 max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-6">
            <div>
              <p className="text-accent text-xs font-semibold tracking-[0.2em] uppercase mb-4">All Services</p>
              <h2 className="font-serif text-4xl lg:text-[52px] text-stone-900 leading-tight max-w-2xl" style={{ letterSpacing: '-0.02em' }}>
                Remodeling Services Built Around Quality, Function &amp; Design
              </h2>
            </div>
            <p className="text-stone-500 text-sm leading-relaxed max-w-sm">
              Every service is delivered with the same standard of precision craftsmanship, transparent process, and long-term durability.
            </p>
          </div>

          {/* Quick navigation pills */}
          <div className="flex flex-wrap gap-3 mt-10">
            {SERVICES.map((s) => (
              <a
                key={s.slug}
                href={`#${s.slug}`}
                className="inline-flex items-center gap-2 border border-stone-200 hover:border-accent hover:text-accent text-stone-600 text-xs font-medium px-4 py-2 rounded-full transition-colors whitespace-nowrap"
              >
                <div className="w-2.5 h-2.5 flex items-center justify-center">
                  <i className="ri-arrow-down-line text-[10px]" />
                </div>
                {s.title}
              </a>
            ))}
          </div>
        </div>

        {/* 6 alternating service sections */}
        <div className="border-t border-stone-100">
          {SERVICE_DETAILS.map((detail, i) => {
            const service = SERVICES.find((s) => s.slug === detail.id);
            return (
              <div key={detail.id} className={`border-b border-stone-100 ${i % 2 === 0 ? '' : 'bg-[#F9F7F3]'}`}>
                <ServiceDetailItem
                  id={detail.id}
                  title={service?.title || ''}
                  description={service?.description || ''}
                  image={detail.image}
                  label={detail.label}
                  reversed={i % 2 !== 0}
                  details={
                    <ul className="flex flex-col gap-2.5">
                      {detail.details.map((item) => (
                        <li key={item} className="flex items-start gap-3 text-stone-600 text-sm">
                          <div className="w-4 h-4 mt-0.5 flex items-center justify-center flex-shrink-0">
                            <i className="ri-check-line text-accent" />
                          </div>
                          {item}
                        </li>
                      ))}
                    </ul>
                  }
                />
              </div>
            );
          })}
        </div>

        {/* Post-services CTA */}
        <div className="px-6 lg:px-16 xl:px-24 py-16">
          <div className="max-w-6xl mx-auto bg-stone-950 rounded-2xl p-8 lg:p-12 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
            <div>
              <p className="font-serif text-2xl text-white mb-2">Ready to start your project in Brandon, FL?</p>
              <p className="text-stone-400 text-sm">Free in-home consultation · Licensed &amp; insured · No obligation</p>
            </div>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 flex-shrink-0">
              <a href={`tel:${COMPANY.phoneFull}`} className="inline-flex items-center gap-2 text-white/70 hover:text-white border border-stone-700 hover:border-accent/40 px-5 py-3 rounded-lg transition-colors whitespace-nowrap text-sm font-medium">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-accent text-xs" />
                </div>
                {COMPANY.phone}
              </a>
              <Link to="/about" className="inline-flex items-center gap-3 bg-accent hover:bg-accent-dark text-white font-semibold px-7 py-3 rounded-lg transition-colors whitespace-nowrap group text-sm">
                Schedule a Consultation
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1 text-xs" />
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 4. AI Answer Block */}
      <AIAnswerBlock
        question="What Services Does Bay City Remodeling Offer?"
        answer="Bay City Remodeling & Bathrooms LLC provides comprehensive residential remodeling services in Brandon, FL and 23+ surrounding communities. Services include kitchen remodeling, bathroom renovations, full home transformations, interior upgrades, and outdoor living spaces — all executed with a structured process, skilled craftsmen, and a commitment to long-term quality."
        bullets={[
          'Kitchen remodeling — custom layouts, cabinetry, countertops, appliances',
          'Bathroom remodeling — spa-level finishes, efficient layouts, premium tile',
          'Full home renovations — cohesive transformation across all areas',
          'Interior upgrades — flooring, cabinetry, trim, built-ins, layout changes',
          'Outdoor living — patios, pergolas, outdoor kitchens for Florida living',
          '18+ years serving Brandon, FL and surrounding communities',
        ]}
      />

      {/* 5. Process */}
      <ProcessSection />

      {/* 6. Why Choose Us */}
      <WhyChooseUs />

      {/* 7. Service Areas */}
      <ServiceAreasSection />

      {/* 8. Testimonials */}
      <TestimonialsSection />

      {/* 9. FAQ */}
      <FAQSection faqs={combinedFaqs} title="Remodeling Services — Questions Answered" />

      {/* 10. Final CTA */}
      <FinalCTA title="Start Your Remodeling Project With Confidence" />

      <Footer />
    </div>
  );
}
